import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    inject,
    input,
    OnInit,
    output,
    signal,
} from '@angular/core';
import { TelXLButtonComponent } from '@dxp/elements';
import { IContact } from '@dxp/core/models';
import { PermissionService } from '@dxp/core/services';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ContactDirectoriesDetailsFormComponent } from '../contact-details-form/contact-details-form.component';
import { ContactDirectoriesDetailsInitialsComponent } from './contact-details-initials/contact-details-initials.component';
import { ContactDetailsService, FormAction } from './contact-details.service';

@Component({
    selector: 'contact-directories-details',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        ContactDirectoriesDetailsInitialsComponent,
        TelXLButtonComponent,
        ContactDirectoriesDetailsFormComponent,
    ],
    templateUrl: './contact-details.component.html',
    styleUrl: './contact-details.component.scss',
})
export class ContactDirectoriesDetailsComponent implements OnInit {
    readonly #destroyRef = inject(DestroyRef);
    readonly #contactDetailsService = inject(ContactDetailsService);
    readonly #permissionService = inject(PermissionService);

    contact = input.required<IContact>();
    updated = output<IContact>();

    canSave$: Observable<boolean>;
    readonly isEditing = signal<boolean>(false);

    constructor() {
        this.canSave$ = this.#contactDetailsService.canSave$;
    }

    ngOnInit() {
        this.#contactDetailsService.isEditing$
            .pipe(takeUntilDestroyed(this.#destroyRef))
            .subscribe(isEditing => {
                this.isEditing.set(isEditing);
            });
    }

    performFormAction(action: FormAction) {
        this.#contactDetailsService.performFormAction(action);
    }

    performEdit() {
        this.#contactDetailsService.updateEditing(true);
    }

    onUpdated(contact: IContact) {
        this.updated.emit(contact);
    }

    get hasCanCreatePermission(): boolean {
        return this.#permissionService.hasAnyPermission([
            'contactdirectory.create',
        ]);
    }

    get hasCanUpdatePermission(): boolean {
        return this.#permissionService.hasAnyPermission([
            'contactdirectory.update',
        ]);
    }
}
